import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import React, { useState } from 'react'
import { storage } from '../utils/firebase';

export default function Image() {
    const [imgSrc, setImgSrc] = useState("")
    const [caption, setCaption] = useState("")
    const [loading, setLoading] = useState(false)

    const handleUpload = async () => {
        const imageRef = ref(storage, `images/${Date.now()}-${imgSrc.name}`);

        try {
            await uploadBytes(imageRef, imgSrc);
            const url = await getDownloadURL(imageRef);
            console.log('Image URL:', url);
            return url;
        } catch (error) {
            console.error('Upload error:', error);
        }
    };

    const getCaption = async () => {
        try {
            setLoading(true)
            console.log("Getting Caption");
            const token = "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"
            const url = await handleUpload()
            console.log("Image Uploaded");
            console.log("Requesting response from openrouter");
            await fetch('https://openrouter.ai/api/v1/chat/completions', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    model: 'mistralai/mistral-small-3.1-24b-instruct:free',
                    // model: 'google/gemini-2.0-flash-exp:free',
                    messages: [
                        {
                            role: 'user',
                            content: [
                                {
                                    "type": "text",
                                    "text": "What is in this image?"
                                },
                                {
                                    "type": "image_url",
                                    "image_url": {
                                        "url": url
                                    }
                                }
                            ]
                        },
                    ],
                }),
            }).then(res => res.json())
                .then(data => {
                    setCaption(data?.choices?.[0]?.message?.content)
                    console.log("Response:", data?.choices?.[0]?.message?.content);
                })
                .catch(err => {
                    console.error("Error:", err);
                });
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log("Error", error);
            alert(error?.message)
        }
    }

    return (
        <div className='Video'>
            <h2>Convert Image To Caption</h2>
            {imgSrc ?
                <div className='Video_Image' style={{ marginTop: 20 }}>
                    <img style={{ width: 500, borderRadius: 10 }} src={URL.createObjectURL(imgSrc)} />
                    <div className='Video_Close' onClick={()=>{
                            setImgSrc("")
                            setCaption("")
                        }}>
                        <CloseIcon />
                    </div>
                </div>
                :
                <>
                    <input hidden id='image-input' type='file' onChange={(e) => setImgSrc(e?.target?.files[0])} accept='image/*' />
                    <label htmlFor='image-input'>Choose Image</label>
                </>}
            {imgSrc ? <button onClick={() => getCaption()}>{loading ? "Please Wait" : "Extract Caption"}</button> : null}
            {caption ? <p>{caption}</p> : null}
            {caption ?
                <>
                    <button onClick={() => {
                        navigator.clipboard.writeText(caption)
                        alert("Copied")
                    }}>Copy plain text</button>
                </>
                : null}
                <div className='Video_End_Con' />
        </div>
    )
}

function CloseIcon() {
    return (
        <svg height={17} width={17} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Menu / Close_SM"> <path id="Vector" d="M16 16L12 12M12 12L8 8M12 12L16 8M12 12L8 16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>
    )
}